module.exports = __webpack_public_path__ + "static/media/CC.bb7cf914.svg";